import { NavLink } from "../../ui";
import { IBreadcrum } from "../../../interfaces";
import { useMemo, useState } from "react";
import { useGlobalContext } from "../../../lib/context";
import { getKeyByValue} from '../../../lib/helpers/common';
import { CountryCode } from "../../../lib/constants";
import { SchemaHead } from "../schemaHead";
import { useRouter } from "next/router";

const skipSlug="author,category,interiors,guides,dashboard,login,register";//"home-construction-and-renovation";
type props = {
    customPageUrl?:string
    containerType?:string
}
export function BreadCrumb ({customPageUrl,containerType = "container"}:props){  
    const [breadcrums, setBreadcrums]=useState<IBreadcrum[]>([]);
    const { props:{pageURL,pageProps,isDubaiPage}} = useGlobalContext();
    const router = useRouter()
    const errorpage = router?.route == "/404" || router?.route == "/500" || pageProps?.pageGone == true
    const hideBreadCrumb = pageURL && (pageURL.includes('homeco') || pageURL.includes('estimate')) || errorpage || router?.query?.isHideLayout
    useMemo(()=>{
        if(pageURL){
            let _breadcrums:IBreadcrum[]=[];
            let _pageURL;
            if(customPageUrl && customPageUrl !== ""){
                _pageURL=customPageUrl
            }
            else 
             _pageURL=router.asPath;
            const _routes= _pageURL.split('?')[0].split('/');
            if(_routes){
                let path="";
                _routes.forEach((route)=>{
                    path=path+'/'+route;        
                    if(skipSlug.split(',').findIndex(f=>f==route) !== -1)return;

                    const title=route.split('-').filter(f=>!["themes","layouts"].includes(f)).join(' ').replace(/(^\w|\s\w)/g, m => m.toUpperCase());
                    if(route && getKeyByValue(CountryCode,route)){
                        path=process.env.SITE_URL+'/'+route;
                        _breadcrums.push({
                            path:path.split("/in")[0].TrimTrailingSlash(),
                            title:'Home'
                        });                        
                    }
                    else if(route && !getKeyByValue(CountryCode,route)){ 
                        if(_breadcrums.length>1 &&  _breadcrums[_breadcrums.length-1].title==="Interior Design Ideas")
                        {
                            _breadcrums.push({
                                path,
                                title: title+ " Design Ideas"
                            });
                        }
                        else if (route && route === 'dubai'){
                            path=process.env.SITE_URL+'/'+route;
                            _breadcrums.push({
                                path,
                                title
                            });
                        }
                        else
                            _breadcrums.push({
                                path,
                                title
                            });
                    }
                });
            }
            setBreadcrums(_breadcrums);
        }
    },[pageURL]);

    if(!breadcrums || breadcrums.length<=1)
        return null;

    const BindBreadCrumb=(data:IBreadcrum, currentIndex:number)=>{
        if(breadcrums.length-1==currentIndex)
            return <li key={currentIndex} title={data.title}>{data.title}</li>
        else
            return <li key={currentIndex} title={data.title}><NavLink exact={true} href={data.path}>{data.title}</NavLink></li>       
    }    

    const schemaData=()=>{
        const itemListElement:string[]=[];
        breadcrums.forEach((d,idx)=>{
            if(breadcrums.length-1==idx)
                itemListElement.push(`{
                    "@type": "ListItem",
                    "position": ${idx+1},
                    "name": "${d.title}"
                }`);
            else
                itemListElement.push(`{
                    "@type": "ListItem",
                    "position": ${idx+1},
                    "name": "${d.title}",
                    "item": "${d.path}"
                }`);
        })

        const _schema={
            __html:`
            {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [${itemListElement}]
            }`
        }
		return _schema;
    }
   if( hideBreadCrumb )return null
   else return (
    <>    
        <SchemaHead data={schemaData()} navSchemaData={[]} />
        <div className={containerType}>
                <div className="breadcrum">
                    <ul>
                        { 
                            breadcrums.map((bc,idx)=>BindBreadCrumb(bc,idx))
                        }
                    </ul>
                </div>
        </div>
    </>
    )
}